import Vue from 'vue'
import { icons } from '@core/utils/icons'

const setIcons = instance => {
  instance.mixin({
    data() {
      return {
        icons,
      }
    },
  })
}

Vue.use(setIcons)
